module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABnSURBVHgB7c6xDYAgEAXQixPY2rGGYziBqziCG2ANJIxhohBGwHgaxjhjT0GwkIJXXu7/fIAqKqya4S6nlN8mduz64SAidlvF4YtzE0sZJWilD06NkOMygr8rIMd/Ye90i0bNUCV5ABRbNfwa8ybUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-y.png
// module id = Xy+y
// module chunks = 1